// extracted by mini-css-extract-plugin
export var logo = "header-module--logo--uqGYJ";
export var navigation = "header-module--navigation--Dle5Q";